"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowPropertiesRowAlignmentDescriptor = exports.TableRowPropertiesHideCellMarkDescriptor = exports.TableRowPropertiesHeaderDescriptor = exports.TableRowPropertiesDivIdDescriptor = exports.TableRowPropertiesCellSpacingDescriptor = exports.TableRowPropertiesCantSplitDescriptor = void 0;
var table_row_properties_1 = require("./table-row-properties");
var TableRowPropertiesCantSplitDescriptor = (function () {
    function TableRowPropertiesCantSplitDescriptor() {
    }
    TableRowPropertiesCantSplitDescriptor.prototype.setProp = function (props, newValue) {
        props.cantSplit = newValue;
    };
    TableRowPropertiesCantSplitDescriptor.prototype.getProp = function (props) {
        return props.cantSplit;
    };
    TableRowPropertiesCantSplitDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseCantSplit;
    };
    return TableRowPropertiesCantSplitDescriptor;
}());
exports.TableRowPropertiesCantSplitDescriptor = TableRowPropertiesCantSplitDescriptor;
var TableRowPropertiesCellSpacingDescriptor = (function () {
    function TableRowPropertiesCellSpacingDescriptor() {
    }
    TableRowPropertiesCellSpacingDescriptor.prototype.setProp = function (props, newValue) {
        props.cellSpacing = newValue;
    };
    TableRowPropertiesCellSpacingDescriptor.prototype.getProp = function (props) {
        return props.cellSpacing;
    };
    TableRowPropertiesCellSpacingDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseCellSpacing;
    };
    return TableRowPropertiesCellSpacingDescriptor;
}());
exports.TableRowPropertiesCellSpacingDescriptor = TableRowPropertiesCellSpacingDescriptor;
var TableRowPropertiesDivIdDescriptor = (function () {
    function TableRowPropertiesDivIdDescriptor() {
    }
    TableRowPropertiesDivIdDescriptor.prototype.setProp = function (props, newValue) {
        props.divId = newValue;
    };
    TableRowPropertiesDivIdDescriptor.prototype.getProp = function (props) {
        return props.divId;
    };
    TableRowPropertiesDivIdDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseDivId;
    };
    return TableRowPropertiesDivIdDescriptor;
}());
exports.TableRowPropertiesDivIdDescriptor = TableRowPropertiesDivIdDescriptor;
var TableRowPropertiesHeaderDescriptor = (function () {
    function TableRowPropertiesHeaderDescriptor() {
    }
    TableRowPropertiesHeaderDescriptor.prototype.setProp = function (props, newValue) {
        props.header = newValue;
    };
    TableRowPropertiesHeaderDescriptor.prototype.getProp = function (props) {
        return props.header;
    };
    TableRowPropertiesHeaderDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseHeader;
    };
    return TableRowPropertiesHeaderDescriptor;
}());
exports.TableRowPropertiesHeaderDescriptor = TableRowPropertiesHeaderDescriptor;
var TableRowPropertiesHideCellMarkDescriptor = (function () {
    function TableRowPropertiesHideCellMarkDescriptor() {
    }
    TableRowPropertiesHideCellMarkDescriptor.prototype.setProp = function (props, newValue) {
        props.hideCellMark = newValue;
    };
    TableRowPropertiesHideCellMarkDescriptor.prototype.getProp = function (props) {
        return props.hideCellMark;
    };
    TableRowPropertiesHideCellMarkDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseHideCellMark;
    };
    return TableRowPropertiesHideCellMarkDescriptor;
}());
exports.TableRowPropertiesHideCellMarkDescriptor = TableRowPropertiesHideCellMarkDescriptor;
var TableRowPropertiesRowAlignmentDescriptor = (function () {
    function TableRowPropertiesRowAlignmentDescriptor() {
    }
    TableRowPropertiesRowAlignmentDescriptor.prototype.setProp = function (props, newValue) {
        props.tableRowAlignment = newValue;
    };
    TableRowPropertiesRowAlignmentDescriptor.prototype.getProp = function (props) {
        return props.tableRowAlignment;
    };
    TableRowPropertiesRowAlignmentDescriptor.prototype.maskValue = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseTableRowAlignment;
    };
    return TableRowPropertiesRowAlignmentDescriptor;
}());
exports.TableRowPropertiesRowAlignmentDescriptor = TableRowPropertiesRowAlignmentDescriptor;
